export default "__VITE_ASSET__e8fc11b1__"